import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AlertDetailPartyIdentity from './AlertDetailPartyIdentity';
import { getAMLSCommonAlertPartyIdentity } from '../../../redux/actions/common';

function mapStateToProps(state) {
  const { alertPartyIdentity = {} } = state.amlsCommon;
  const { data, error, isLoading } = alertPartyIdentity;

  return {
    alertPartyIdentity: data,
    error,
    isLoading
  };
}

function mapDispatchToProps(dispatch) {
  return {
    apiActions: bindActionCreators(
      { getAMLSCommonAlertPartyIdentity },
      dispatch
    )
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AlertDetailPartyIdentity);
